import React, { useState } from 'react';
import { Card, Flex, Text, Button } from '@aws-amplify/ui-react';

function DatePicker({ selectedDate, onDateChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const formatWorkingFolder = (date) => {
    const year = date.getFullYear();
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const day = date.toISOString().split('T')[0];
    return `${year}/${month}/${day}`;
  };

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();

    const days = [];
    
    // Add empty cells for days before the first day of the month
    for (let i = 0; i < startingDayOfWeek; i++) {
      days.push(null);
    }
    
    // Add days of the month
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(new Date(year, month, day));
    }
    
    return days;
  };

  const handleDateSelect = (date) => {
    onDateChange(date);
    setIsOpen(false);
  };

  const navigateMonth = (direction) => {
    setCurrentMonth(prev => {
      const newMonth = new Date(prev);
      newMonth.setMonth(prev.getMonth() + direction);
      return newMonth;
    });
  };

  const days = getDaysInMonth(currentMonth);
  const monthYear = currentMonth.toLocaleDateString('en-US', { 
    month: 'long', 
    year: 'numeric' 
  });

  return (
    <div style={{ position: 'relative' }}>
      <Button
        variation="link"
        onClick={() => setIsOpen(!isOpen)}
        style={{ 
          justifyContent: 'flex-start',
          fontSize: '0.8rem',
          padding: '0.4rem 0.5rem',
          width: '100%'
        }}
      >
        📅 {selectedDate ? formatDate(selectedDate) : 'Select Date'}
      </Button>
      
      {isOpen && (
        <Card
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            zIndex: 1000,
            marginTop: '0.25rem',
            padding: '0.5rem'
          }}
        >
          <Flex direction="column" gap="0.5rem">
            <Flex justifyContent="space-between" alignItems="center">
              <Button size="small" onClick={() => navigateMonth(-1)}>‹</Button>
              <Text fontSize="0.9rem" fontWeight="bold">{monthYear}</Text>
              <Button size="small" onClick={() => navigateMonth(1)}>›</Button>
            </Flex>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(7, 1fr)',
              gap: '0.1rem',
              fontSize: '0.7rem'
            }}>
              {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map(day => (
                <Text key={day} textAlign="center" fontWeight="bold" color="gray">
                  {day}
                </Text>
              ))}
              
              {days.map((day, index) => (
                <Button
                  key={index}
                  size="small"
                  variation={day && selectedDate && day.toDateString() === selectedDate.toDateString() ? 'primary' : 'link'}
                  onClick={() => day && handleDateSelect(day)}
                  disabled={!day}
                  style={{
                    fontSize: '0.7rem',
                    padding: '0.2rem',
                    minHeight: '1.5rem',
                    opacity: day ? 1 : 0
                  }}
                >
                  {day ? day.getDate() : ''}
                </Button>
              ))}
            </div>
            
            {selectedDate && (
              <Text fontSize="0.7rem" color="gray" textAlign="center">
                Folder: {formatWorkingFolder(selectedDate)}
              </Text>
            )}
          </Flex>
        </Card>
      )}
    </div>
  );
}

export default DatePicker;